/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Page_Download_TitleInputs */

const en_pc_page_download_title = /** @type {(inputs: Pc_Page_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download PhotoCraft ArtCraft for Mac, Windows and Linux`)
};

const zh_pc_page_download_title = /** @type {(inputs: Pc_Page_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft ArtCraft 下载：Mac、Windows、Linux`)
};

/**
* | output |
* | --- |
* | "Download PhotoCraft ArtCraft for Mac, Windows and Linux" |
*
* @param {Pc_Page_Download_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_page_download_title = /** @type {((inputs?: Pc_Page_Download_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Page_Download_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_page_download_title(inputs)
	return zh_pc_page_download_title(inputs)
});
export { pc_page_download_title as "pc.page.download.title" }